import MenuSurveyList from './MenuSurveyList';


export default {
    list : MenuSurveyList,
    
};